import { WorkType } from '@warehouse/title-shared/core';
import { TitleFull } from '@warehouse/title/core';
import {
	compilationUuid,
	editUuid,
	episodeUuid,
	getWorkTypeUuid,
	manifestationUuid,
	movieUuid,
	seasonUuid,
	seriesUuid,
	supplementalUuid,
} from '@warehouse/title/infra';

export type ChildrenTableType = 'entries' | 'seasons' | 'episodes' | 'edits' | 'manifestations' | 'default';

export function getTitleWorkTypeUuid(title: TitleFull): string | undefined {
	const workType = title?.readonly?.workType;
	return workType ? getWorkTypeUuid(workType) : undefined;
}

export function getChildrenTableType(
	parentWorkTypeUuid: string | undefined,
	childWorkType: WorkType,
): ChildrenTableType {
	switch (parentWorkTypeUuid) {
		case compilationUuid():
		case manifestationUuid():
			return childWorkType === WorkType.Manifestation ? 'manifestations' : 'entries';
		case seasonUuid():
			return childWorkType === WorkType.Manifestation ? 'manifestations' : 'episodes';
		case seriesUuid():
			if (childWorkType === WorkType.Manifestation) return 'manifestations';
			if (childWorkType === WorkType.Episode) return 'episodes';
			return 'seasons';
		case movieUuid():
		case episodeUuid():
		case supplementalUuid():
			return 'edits';
		case editUuid():
			return childWorkType === WorkType.Manifestation ? 'manifestations' : 'edits';
		default:
			return 'default';
	}
}
